import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import {
  CUSTOMER_STATUS,
  FUNCTION_RESULT_STATUS,
  ICustomer,
} from "@nova/common-interfaces"; // Adjust path as needed
import { CommonComponent } from "../../../../../lib/components/index.mjs";
import { CustomerService } from "../../../../shared/services/customers/customers.service.mjs";

@Component({
  selector: "app-customer-form",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./customer-create.component.html",
  styleUrls: ["./customer-create.component.scss"], // Fixed typo
})
export class CustomerCreateComponent extends CommonComponent implements OnInit {
  customerForm!: FormGroup;
  customerStatuses = Object.values(CUSTOMER_STATUS);

  constructor(
    private fb: FormBuilder,
    protected customerService: CustomerService,
    protected router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.customerForm = this.fb.group({
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      phone_number: [""],
      latitude: [null],
      longitude: [null],
      autopay_status: [false, Validators.required],
      mailing_address: this.fb.group({
        street: [""],
        // Add other mailing address fields here
      }),
    });
  }

  async onSubmit(): Promise<void> {
    if (this.customerForm.valid) {
      this.isLoading(true);
      const customer = {} as ICustomer;

      await this.customerService
        .insert(customer)
        .then((result) => {
          if (result.status !== FUNCTION_RESULT_STATUS.SUCCESS) {
            console.error("Error saving new customer", result);
            return;
          }

          this.router.navigate(["/admin/customers"]);
        })
        .finally(() => {
          this.isLoading(false);
        });
    }
  }
}
